import { render, staticRenderFns } from "./TAS.vue?vue&type=template&id=1cf362a1&scoped=true&"
import script from "./TAS.vue?vue&type=script&lang=js&"
export * from "./TAS.vue?vue&type=script&lang=js&"
import style0 from "./TAS.vue?vue&type=style&index=0&id=1cf362a1&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf362a1",
  null
  
)

export default component.exports